import { Container } from "./style";

export default function NotFound() {
    return(
        <Container>
            <h1>Página não encontrada!</h1>
        </Container>
    );
}